export const getJobTimePromptEnabled = (state) => {
  return state?.companySettings?.jobTimePromptEnabled ?? false;
};
